import { useState } from "react";
import { Box, Drawer } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getTaskStatusLabels } from "../../../utils/constant";
import { getUserProfileDetails } from "../../../appStore/actions/AppState/action";
import { findUser, setProfileData } from "../../../utils/helper";
import { useTranslation } from "react-i18next";
import TaskCard from "../../../common/TaskCard/TaskCard";
import SubTaskCard from "../../../common/SubTaskCard/SubTaskCard";
import ReopenedHistory from "./Drawer/ReopenedHistory";

const TaskMessage = ({
  taskItem,
  startTaskOpen,
  setStartTaskOpen,
  handleStartTask,
  indx,
  handleClickTaskUpdate,
  handleViewThreadClick,
  tabValue,
  taskTabValue,
  recipientDetails
}) => {
  const { t } = useTranslation();
  const appConstant = t("AppConstant", { returnObjects: true });
  const taskStatusLabels = getTaskStatusLabels(appConstant);
  const [profileViewData, setProfileViewData] = useState("");
  const [isProfileViewOpen, setProfileViewModal] = useState(false);
  const [reopenedHostoryDrawer, setReopenedHostoryDrawer] = useState(false);

  const groupmemberdetails = useSelector(
    (state) => state?.arkchatgroup?.groupmember
  );
  const groupList = useSelector((state) => state?.arkchatgroup?.groupList);
  const userData = useSelector((state) => state?.profile);
  const dispatch = useDispatch();

  const handleShowUserProfile = (userToFindData) => {
    let data = findUser(groupmemberdetails, userToFindData);

    if (!data) {
      setProfileViewModal(true);
      dispatch(getUserProfileDetails(userToFindData)).then((res) => {
        data = res;
        setProfileData(data, setProfileViewData, setProfileViewModal);
      });
    } else {
      setProfileData(data, setProfileViewData, setProfileViewModal);
    }
  };

  return (
    <>
      <Box
        draggable
        sx={{
          transition: "all 0.2s ease",
        }}
      >
        <Box
          padding="0px 20px 15px 0px"
          key={taskItem?.id + "TaskMessageMain"}
          sx={{}}
          display={"flex"}
          alignItems={"center"}
        >
          {/* Drag Handle */}

          <Box
            sx={{
              width: "100%",
              border: "1px solid rgba(0, 0, 0, 0.1)",
              borderRadius: "19.5px",
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "9px 20px 9px 12px",
            }}
          >
            <TaskCard
              taskItem={taskItem}
              setStartTaskOpen={setStartTaskOpen}
              handleStartTask={handleStartTask}
              indx={indx}
              handleClickTaskUpdate={handleClickTaskUpdate}
              handleViewThreadClick={handleViewThreadClick}
              tabValue={tabValue}
              taskTabValue={taskTabValue}
              userData={userData}
              groupList={groupList}
              taskStatusLabels={taskStatusLabels}
              setProfileViewModal={setProfileViewModal}
              isProfileViewOpen={isProfileViewOpen}
              profileViewData={profileViewData}
              setProfileViewData={setProfileViewData}
              handleShowUserProfile={handleShowUserProfile}
              startTaskOpen={startTaskOpen}
              setReopenedHostoryDrawer={setReopenedHostoryDrawer}
              recipientDetails={recipientDetails}
            />
          </Box>
        </Box>
        {taskItem?.balah?.map((subItem, subIndx) => (
          <Box
            padding="0px 20px 15px 0px"
            key={subItem?.id + "TaskMessageSub1"}
            display={"flex"}
            alignItems={"center"}
          >
            <SubTaskCard
              taskItem={subItem}
              setStartTaskOpen={setStartTaskOpen}
              handleStartTask={handleStartTask}
              indx={subIndx + "subtask"}
              subIndex={0}
              handleClickTaskUpdate={handleClickTaskUpdate}
              handleViewThreadClick={handleViewThreadClick}
              tabValue={tabValue}
              taskTabValue={taskTabValue}
              userData={userData}
              groupList={groupList}
              taskStatusLabels={taskStatusLabels}
              setProfileViewModal={setProfileViewModal}
              isProfileViewOpen={isProfileViewOpen}
              profileViewData={profileViewData}
              setProfileViewData={setProfileViewData}
              handleShowUserProfile={handleShowUserProfile}
              startTaskOpen={startTaskOpen}
              recipientDetails={recipientDetails}
            />
          </Box>
        ))}
      </Box>
      <Drawer
        disableEnforceFocus
        // hideBackdrop={true}
        anchor={"right"}
        open={reopenedHostoryDrawer}
      >
        <ReopenedHistory
          taskItem={taskItem}
          setReopenedHostoryDrawer={setReopenedHostoryDrawer}
        />
      </Drawer>
    </>
  );
};

export default TaskMessage;
